import React from 'react';
import { SelectOption } from 'global';
import { HelpOutline } from '@mui/icons-material';
import { Box, Tooltip, Typography, Stack } from '@mui/material';

interface Props {
  report: SelectOption[];
}

export const ReportInfo = ({ report }: Props) => {
  return (
    <Box
      sx={{
        width: '100%',
        padding: '1rem',
        borderRadius: 1,
        border: '1px solid',
        borderColor: 'divider',
        boxShadow: ({ shadows }) => shadows[1],
      }}
    >
      <Stack gap="0.5rem">
        {report.map(({ value, label }) => (
          <Box key={label} sx={{ display: 'grid', gridTemplateColumns: '12rem 1fr', gap: '0.5rem' }}>
            <Stack direction="row" alignItems="center" gap="0.25rem">
              <Typography variant="subtitle2" component="span">
                {label}
              </Typography>

              <Tooltip title={label}>
                <HelpOutline fontSize="small" color="disabled" />
              </Tooltip>
            </Stack>

            <Typography>{value ?? 'N/A'}</Typography>
          </Box>
        ))}
      </Stack>
    </Box>
  );
};
